const SETTINGS_KEY = 'sc-settings';
const DEFAULTS = {
  theme: 'light', fontSize: 'medium', animations: true,
  soundEffects: true, voicePrompts: false,
};

export function loadSettings() {
  try { return { ...DEFAULTS, ...JSON.parse(localStorage.getItem(SETTINGS_KEY) || '{}') }; }
  catch { return { ...DEFAULTS }; }
}

export function applySettings(s) {
  const el = document.documentElement;

  // Always light mode
  el.setAttribute('data-theme', 'light');

  // Font size
  el.setAttribute('data-font-size', s.fontSize || 'medium');

  // Animations
  if (s.animations === false) el.setAttribute('data-no-anim', '');
  else el.removeAttribute('data-no-anim');
}

// Call once on app boot (before React renders) so there's no flash
applySettings(loadSettings());
